
<div>
    <img [src]="loginUrl" style='display:none;'>
</div>
